<template>
    <v-card>
        <v-snackbar
            v-model="snackbar"
            :color="color"
            right
            top
            app
            >
            {{snackbarText}}
            <v-btn
                text
                dark
                @click="snackbar = false"
            >
                Fermer
            </v-btn>
        </v-snackbar>
        <v-card-title>
        <span>Ajouter Navire</span>
        </v-card-title>
        <v-card-text>
            <v-container>
                <v-row>
                <v-col cols="12" sm="6" md="6">
                    <v-text-field label="Code Navire*" v-model="navireTmp.code_nav" disabled required></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                    <v-text-field label="Titre Navire" v-model="navireTmp.titre" hint="exemple : GAS SNAPPER"></v-text-field>
                </v-col>
                <v-col cols="12">
                    <v-text-field label="Code O.M.I*" v-model="navireTmp.code_omi" required></v-text-field>
                </v-col>
                <v-col cols="12">
                    <v-text-field label="Nationalité" v-model="navireTmp.nationalite" required></v-text-field>
                </v-col>
                <v-col cols="12" sm="4">
                    <v-text-field label="Longueur" v-model="navireTmp.long_tirant" required></v-text-field>
                </v-col>
                <v-col cols="12" sm="4">
                    <v-text-field label="Largeur" v-model="navireTmp.larg_tirant" required></v-text-field>
                </v-col>
                <v-col cols="12" sm="4">
                    <v-text-field label="Tirant Eau" v-model="navireTmp.tirant_eau" required></v-text-field>
                </v-col>
                <v-col cols="12" sm="4">
                    <v-text-field label="Tirant Air" v-model="navireTmp.tirant_air" required></v-text-field>
                </v-col>
                <v-col cols="12" sm="4">
                    <v-text-field label="Pavillon" v-model="navireTmp.pavillon" required></v-text-field>
                </v-col>
                <v-col cols="12" sm="4">
                    <v-text-field label="Conducteur" v-model="navireTmp.conducteur" required></v-text-field>
                </v-col>
                <v-col cols="12" sm="4">
                    <v-text-field label="Jauge Brute" v-model="navireTmp.jauge_brute" required></v-text-field>
                </v-col>
                <v-col cols="12" sm="4">
                    <v-text-field label="Jauge Net" v-model="navireTmp.jauge_net" required></v-text-field>
                </v-col>
                <v-col cols="12" sm="4">
                    <v-text-field label="CPAV" v-model="navireTmp.cpav" required></v-text-field>
                </v-col>
                </v-row>
            </v-container>
            <small>*toutes les cases indiquées avec étoiles sont obligatoires</small>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDialog">Fermer</v-btn>
                <v-btn style="background: linear-gradient(90deg, rgba(13,74,186,1) 0%, rgba(9,155,223,1) 100%); box-shadow:0 0 20px rgba(0,0,0,0.2); color: white;" @click="addNavire">Ajouter</v-btn>
            </v-card-actions>
    </v-card>
</template>
<script>
export default {
    name: 'add-navire',
    data: () => ({
        snackbar: false,
        snackbarText: '',
        color: "success",
        navireTmp: {
            code_nav:'',
            titre:'',
            long_tirant:'',
            tirant_air:'',
            larg_tirant:'',
            code_omi:'',
            pavillon:'',
            conducteur:'',
            jauge_brute:'',
            jauge_net:'',
            cpav:'',
            nationalite:'',
            tirant_eau:''
        },
        navires: []
    }),
    mounted(){
        this.axios
          .get('/navire/listing')
          .then(response => 
              {
                if(response.data.length > 0){
                    var nextCode = response.data.reduce((max, p) => p.code_nav > max ? p.code_nav : max, response.data[0].code_nav)
                    if(Number(nextCode.slice(0, 4)) === new Date().getFullYear() ) {
                        nextCode = Number(nextCode)+1
                    }else{
                        nextCode = new Date().getFullYear()+'0001';
                    }
                }else{
                    nextCode = new Date().getFullYear()+'0001';
                }
                this.navireTmp.code_nav = nextCode
              })
        
    },
    methods: {
        closeDialog(){
            this.$emit('close', true)
        },
        addNavire() {
            this.axios.post('/navire/create', this.navireTmp, {
            }).then((res) => {
                if(res.data === 'error'){
                this.color = "error"
                this.snackbarText = "Essayez de remplir tous les champs obligatoires."
                this.snackbar = true
                }else{
                this.color = "success"
                this.snackbarText = "Le navire a été ajouté avec succès."
                this.snackbar = true
                this.$emit('reloadData', true)
                this.closeDialog()
                }
                
            }).catch(e => {
                this.color = "error"
                this.snackbar = true
                this.snackbarText = "Un erreur est survenu, essayez plus tard."
                console.log(e)
            })
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/views/dashboard/database/navire/add.component.vue